import { X } from 'lucide-react'

import { Button } from '@/ui-components/Button'
import { Dialog, DialogActions, DialogDescription, DialogTitle } from '@/ui-components/Dialog'

export type ConfirmationModalProps = {
  isOpen: boolean
  onClose: () => void
  title: string
  description: string
  confirmText?: string
  confirmLoadingText?: string
  confirmColour?: 'primary' | 'red'
  isLoading: boolean
  onConfirm: () => void
}

export const ConfirmationModal = ({
  isOpen = false,
  onClose,
  title,
  description,
  confirmText = 'Confirm',
  confirmLoadingText = 'Confirming...',
  confirmColour = 'primary',
  isLoading,
  onConfirm,
}: ConfirmationModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>
        <div className="flex justify-between items-center">
          <span>{title}</span>
          <Button
            plain
            onClick={onClose}
            aria-label="Close"
          >
            <X data-slot="icon" />
          </Button>
        </div>
      </DialogTitle>
      <DialogDescription>{description}</DialogDescription>
      <DialogActions>
        <Button
          outline
          className="disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isLoading}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          color={confirmColour}
          className="disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isLoading}
          onClick={onConfirm}
        >
          {isLoading ? confirmLoadingText : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationModal
